import Contact from './templates/Contact.jsx';
import Counter from './templates/Counter.jsx';
import Profile from './templates/Profile'
import Projects from './templates/Projects.jsx';
import Services from './templates/Services'
import TechStack from './templates/TechStack.jsx';
import Testimonials from './templates/Testimonials.jsx';
import { BackgroundBeams } from './templates/components/ui/background-beams.tsx';
import { GlowingEffect } from './templates/components/ui/glowing-effect.tsx';
import { BriefcaseBusiness, UsersRound, Star } from 'lucide-react'

function App() {
  return (
    <div className="App w-full flex justify-center p-6 h-screen">
      <div className="w-full h-full grid grid-cols-3 gap-4 relative z-20">
        <div className="col-span-3 md:col-span-3 lg:col-span-1 xl:col-span-1 flex flex-col gap-4">
          <GridItem component={<Profile />} />
          <GridItem component={<Services />} />
        </div>
        <div className="col-span-3 md:col-span-3 lg:col-span-1 xl:col-span-1 flex flex-col gap-4">
          <GridItem component={<Projects />} />
          <div className='grid grid-cols-3 gap-4'>
            <GridItem component={
              <Counter 
                count={10}
                icon={<BriefcaseBusiness className='w-3 h-3 lg:w-5 lg:h-5 xl:w-5 xl:h-5 text-blue-500' />}
                text="Projects"
              />} 
            />
            <GridItem component={
              <Counter 
                count={10}
                icon={<UsersRound className='w-3 h-3 lg:w-5 lg:h-5 xl:w-5 xl:h-5 text-blue-500' />}
                text="Clients"
              />} 
            />
            <GridItem component={
              <Counter 
                count={3}
                icon={<Star className='w-3 h-3 lg:w-5 lg:h-5 xl:w-5 xl:h-5 text-blue-500' />}
                text="Experience"
                yrs={true}
              />} 
            />
          </div>
          <div className='lg:hidden xl:hidden'>
            <GridItem component={<TechStack />} />
          </div>
          <GridItem component={<Contact />} />
        </div>
        <div className="col-span-3 md:col-span-3 flex flex-col gap-4 lg:col-span-1 xl:col-span-1 lg:pb-0 pb-6 hidden lg:block xl:block">
          <GridItem component={<TechStack />} />
        </div>
      </div>
      {/* <BackgroundBeams className="z-10 opacity-40" /> */}
    </div>
  );
}

const GridItem = ({component}) => {
  return (
      <div className="relative rounded-xl border border-gray-600 p-2">
          <GlowingEffect
            spread={40}
            glow={true}
            disabled={false}
            proximity={64}
            inactiveZone={0.01}
          />
          <div className="relative overflow-hidden rounded-lg shadow-[0px_0px_20px_0px_#3F3F3F] border-1  p-2">
              {component}
          </div>
      </div>
  );
};

export default App;
